function getPreviewToken(app) {
  if (app && app.ctx && app.ctx.router) {
    const {
      previewToken
    } = app.ctx.router.query;
    return previewToken || null;
  }
  if (typeof window === 'undefined') return null;
  const url = new URL(window.location.href);
  return url.searchParams.get('previewToken');
}
export default getPreviewToken;
//# sourceMappingURL=get-preview-token.js.map